import { ClockCircleOutlined, CloseCircleFilled } from '@ant-design/icons';
import { type Destinatario } from '@framework/api-client/api/inquiries-compile/schemas/destinatario.ts';
import { EnumDestinatarioStatoComunicazione } from '@framework/api-client/api/inquiries-compile/schemas/enumDestinatarioStatoComunicazione.ts';
import { EnumDestinatarioStatoProtocollazione } from '@framework/api-client/api/inquiries-compile/schemas/enumDestinatarioStatoProtocollazione.ts';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { CommunicationLogic } from '../logic/CommunicationLogic.ts';

export interface ICommunicationRecipientStatusIconProps {
  recipient: Destinatario | null | undefined;
}

/**
 * Mostra i dettagli dello stato di invio di un destinatario di una
 * comunicazione.
 */
export function CommunicationRecipientStatusIcon(
  props: ICommunicationRecipientStatusIconProps,
) {
  const { recipient } = props;

  const theme = useTheme();
  const { t } = useTranslation();

  // Nessun dato sul destinatario
  if (!recipient) return null;

  if (CommunicationLogic.hasRecipientErrors(recipient)) {
    const errorMessage =
      recipient.statoComunicazione ===
      EnumDestinatarioStatoComunicazione.FALLIMENTO
        ? t(
            'communications.error-in-sending-communication',
            "Errore nell'invio della comunicazione",
          )
        : recipient.statoProtocollazione ===
            EnumDestinatarioStatoProtocollazione.FALLIMENTO
          ? t(
              'communications.error-protocolling-communication',
              'Errore nella protocollazione della comunicazione',
            )
          : t(
              'communications.error-in-communication',
              'Errore nella comunicazione',
            );

    return (
      <Tooltip title={errorMessage}>
        <CloseCircleFilled
          aria-label={errorMessage}
          style={{
            color: theme.colorError,
            verticalAlign: '-0.2em',
          }}
        />
      </Tooltip>
    );
  }

  if (
    recipient.statoComunicazione ===
    EnumDestinatarioStatoProtocollazione.IN_LAVORAZIONE
  ) {
    return (
      <Tooltip
        title={t('communications.in-working', 'Comunicazione in lavorazione')}
      >
        <ClockCircleOutlined
          aria-label="Comunicazione in lavorazione"
          style={{
            color: theme.colorInfo,
            verticalAlign: '-0.2em',
          }}
        />
      </Tooltip>
    );
  }

  return null;
}
